import { getTranslations } from "next-intl/server";
const DeliveryPromise = async () => {
  const t = await getTranslations("Common");
  return <div className="bg-productDetails-textBg my-4 flex items-center justify-between space-x-4 py-3 rtl:space-x-reverse" data-sentry-component="DeliveryPromise" data-sentry-source-file="DeliveryPromise.jsx">
      <div className="w-full text-center">
        <p className="text-productDetails-subHeadingText text-xs font-medium md:text-base">
          {t("Custom_Made")}
        </p>
        <p className="text-productDetails-subText text-xs md:text-sm">
          {t("Typically_Ships_In_12_14_Days")}
        </p>
      </div>
      <div className="bg-productDetails-subText h-6 w-px" />
      <div className="w-full text-center">
        <p className="text-productDetails-subHeadingText text-xs font-medium md:text-base">
          {t("Free_Return")}
        </p>
        <p className="text-productDetails-subText text-xs md:text-sm">
          {t("Easy_Risk_Free_Return_In_45_Days")}
        </p>
      </div>
    </div>;
};
export default DeliveryPromise;